import React from "react";
import { Footer } from "../global/footer";

interface Props {}

export const LayoutWhite: React.FC<Props> = props => {
  return (
    <div className="layout--white">
      {props.children}
      <Footer />
    </div>
  );
};
